export default __webpack_public_path__ + "static/media/m_engineering_card26_2.dd0098cf.png";